export enum CashierFeatureFlags {
  BgSignupHidePin = 'bg-signup-hide-pin',
  BlackListCheck = 'blacklist-check',
  DeLugasReregistration = 'de-lugas-reregistration',
  DepositReverseCTAVerify = 'deposit-reverse-cta-verify',
  DisablePendingWithdrawalCancellation = 'swc-disable-pending-withdrawal-cancellation',
  DisplayConvertedAmount = 'display-converted-amount',
  HardVerificationV2 = 'HardVerificationV2',
  HardVerificationV3 = 'HardVerificationV3',
  LowBalancePrompt = 'wc2-balance-low-prompt',
  PsnBalanceNotClickable = 'psn-balance-not-clickable',
  PsnHideBalance = 'psn-hide-balance',
  PsnHideDeposit = 'psn-hide-deposit',
  PsnHideEntireHeader = 'psn-hide-entire-header',
  PsnHideFullName = 'psn-hide-full-name',
  PsnHideUserId = 'psn-hide-user-id',
  PsnHideViewBalances = 'psn-hide-view-balances',
  PsnHideWithdraw = 'psn-hide-withdraw',
  RmfEmployerInfo = 'rmf-employer-info',
  SwcAccountHistoryNetDepositValues = 'ShowUKNetDepositValues',
  SwcAffiliateBonus = 'swc-affiliate-bonus',
  SwcCashier = 'swc-cashier',
  SwcCreditTime = 'swc-credit-time',
  SwcCurrencyManagementCes = 'swc-currency-management-ces',
  SwcDefaultCurrencyBlock = 'swc-default-currency-block',
  SwcDeposit = 'swc-deposit',
  SwcDepositCes = 'swc-deposit-ces',
  SwcDepositLimitButtonDisplay = 'swc-depositlimit-button-display',
  SwcDepositLimitCurrencyConversionInfo = 'swc-depositlimit-currency-conversion-info',
  SwcDepositMethodMinimum = 'swc-deposit-method-minimum',
  SwcDepositReloader = 'swc-deposit-reloader',
  SwcDisableRmfTransition = 'swc-disablermftransition',
  SwcDisableSignupTransition = 'swc-disablesignuptransition',
  SwcDispalyAutoConversionCTA = 'swc-display-autoconversion-cta',
  SwcECheckConfirmation = 'swc-eCheck-confirmation',
  SwcEmailVerification = 'swc-email-verification',
  SwcExitFlow = 'swc-exit-flow',
  SwcExploreCta = 'swc-explore-cta',
  SwcForceWithdrawal = 'swc-force-withdrawal',
  SwcHideBonusIconFromProgressBar = 'swc-hide-bonus-icon-from-progress-bar',
  SwcHideFxInfo = 'swc-hide-fx-info',
  SwcIncodeAllowFailedResult = 'swc-incode-allow-failed-result',
  SwcIncodeContinueOnDesktop = 'swc-incode-continue-to-desktop',
  SwcLugasMessage = 'swc-lugas-message',
  SwcManageCurrencies = 'swc-manage-currencies',
  SwcManageDepositLimits = 'swc-manage-deposit-limits',
  SwcMethodVerificationDeposit = 'swc-method-verification-deposit',
  SwcMethodVerificationWithdraw = 'swc-method-verification-withdraw',
  SwcMethodsManagement = 'swc-methods-management',
  SwcNewCashierNotification = 'swc-new-cashier-notification',
  SwcNewPromotionalContent = 'swc-new-promotional-content',
  SwcNewSignupCountryImage = 'swc-new-signup-country-image',
  SwcOnboardingProgressbar = 'swc-onboarding-progressbar',
  SwcP2pCes = 'swc-p2p-ces',
  SwcP2pTransfer = 'swc-p2ptransfer',
  SwcPaypalSandboxQA = 'swc-paypal-sandbox-qa',
  SwcRMFPhoneVerification = 'swc-rmf-phone-verification',
  SwcRMFPhoneVerificationStatus = 'swc-rmf-phone-verification-status',
  SwcRMFTransition = 'swc-rmf-transition',
  SwcReloaderBonus = 'swc-reloader-bonus',
  SwcRetryDOB = 'swc-retry-dob',
  SwcRetryFiscalCode = 'swc-retry-fiscalcode',
  SwcRetryGender = 'swc-retry-gender',
  SwcRetryPOB = 'swc-retry-pob',
  SwcRetryPhoneNumber = 'swc-retry-phonenumber',
  SwcRetryScreen = 'swc-retry-screen',
  SwcRmf = 'swc-rmf',
  SwcRmfAddressSearch = 'swc-rmf-address-search',
  SwcRmfBonusScreen = 'swc-rmf-bonus-screen',
  SwcRmfFeedbackCsat = 'swc-rmf-feedback-csat',
  SwcRmfNoLimits = 'swc-rmf-no-limits',
  SwcRmfShowOnlyWeeklyLimit = 'swc-rmf-show-only-weekly-limit',
  SwcRmfUKPhoneAfterAddress = 'swc-rmf-uk-phone-after-address',
  SwcRmfUKPhoneAfterName = 'swc-rmf-uk-phone-after-name',
  SwcRmfUKPlayerFundsProtectionFirst = 'swc-rmf-pfp-screen-first',
  SwcSGScreen = 'swc-sg-screen',
  SwcSSN9 = 'swc-ssn9',
  SwcSignup = 'swc-signup',
  SwcSignupConsentPreferences = 'swc-signup-consentpreferences',
  SwcSignupDeposit = 'swc-signup-deposit',
  SwcSignupOnePage = 'swc-signup-onepage',
  SwcSignupPhoneCollection = 'swc-signup-phone-collection',
  SwcSignupPinConfirmation = 'swc-signup-pin-confirmation',
  SwcSignupRmf = 'swc-signup-rmf',
  SwcSignupRmfAutofocus = 'swc-signup-rmf-autofocus',
  SwcSignupRmfEcoEransitionTwo = 'swc-signup-rmf-ecotransitiontwo',
  SwcSignupRmfEcopokerLobby = 'swc_signup_rmf_ecopokerlobby',
  SwcSignupRmfSumSub = 'swc-signup-rmf-sumsub',
  SwcSwapCTAOrder = 'swc-swap-cta-order',
  SwcTransactionHistoryCes = 'swc-transaction-history-ces',
  SwcTransactionHistoryDownload = 'swc-transaction-history-download',
  SwcTransactionHistoryResults = 'swc-transaction-history-results',
  SwcTurorial = 'swc-tutorial',
  SwcUSPAEnhancedFlow = 'swc-uspa-enhanced-flow',
  SwcWebTokenResolve = 'swc-web-token-resolve',
  SwcWelcomeBonusScreen = 'swc-welcomebonus-screen',
  SwcWithdrawCes = 'swc-withdraw-ces',
  SwcWithdrawal = 'swc-withdrawal',
  SwcWithdrawalCreditTime = 'swc-withdrawal-credit-time',
  SwcWithdrawalMethodMinimum = 'swc-withdrawal-method-minimum',
  SwcXpayLibraryTestStatus = 'swc-xpay-library-test-status',
  Wc2HidePlayMoneyButton = 'wc2-hide-play-money-button',
  Wc2PlayMoney = 'wc2-playmoney',
  WrmfAcAutotrigger = 'wrmf-ac-autotrigger',
  WrmfKBA = 'wrmf-kba'
}
